// src/converters/season-team.ts
import { SeasonTeam, Team } from '@/model';
import {
  SeasonTeamItemResponse,
  GetSeasonTeamsResponse,
  PostSeasonTeamResponse,
  PostSeasonTeamsBatchResponse,
} from '@/services/response/season-team';
import { StageTeamSummaryResponse } from '@/services/response/stage';

const mapTeamSummary = (response: StageTeamSummaryResponse): Team => ({
  uuid: response.uuid,
  name: response.name,
  acronym: response.acronym ?? '',
  logo_path: response.logo_path,
} as unknown as Team);

const mapItem = (response: SeasonTeamItemResponse): SeasonTeam => ({
  uuid: response.uuid,
  season_uuid: response.season?.uuid,
  team_uuid: response.team.uuid,
  team: mapTeamSummary(response.team),
  created_at: response.created_at,
  updated_at: response.updated_at,
});

export class SeasonTeamConverter {
  static toDomainFromPaginatedResponse(response: GetSeasonTeamsResponse): SeasonTeam[] {
    return response.data.map(mapItem);
  }

  static toDomainFromPostResponse(response: PostSeasonTeamResponse): SeasonTeam {
    return mapItem(response);
  }

  static toDomainFromPostBatchResponse(
    response: PostSeasonTeamsBatchResponse,
  ): SeasonTeam[] {
    return response.data.map(mapItem);
  }
}
